<div class="p-4">
  <h2 class="text-2xl font-semibold text-gray-800 mb-6">Dashboard</h2>

  <!-- Feature Cards Grid -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    <!-- Standard Floor Plans Card -->
    <a
      routerLink="/standard-floor-plan"
      class="bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group"
    >
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <div
            class="w-12 h-12 bg-[rgb(134,158,163)] bg-opacity-10 rounded-lg flex items-center justify-center group-hover:bg-opacity-20 transition-all duration-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-[rgb(134,158,163)]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              />
            </svg>
          </div>
          <div
            class="text-[rgb(134,158,163)] group-hover:translate-x-1 transition-transform duration-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
        <h3
          class="text-xl font-semibold text-gray-800 mb-2 group-hover:text-[rgb(134,158,163)] transition-colors duration-300"
        >
          Standard Floor Plans
        </h3>
        <p class="text-gray-600">Manage and organize standard floor plans for your properties.</p>
      </div>
      <div class="px-6 py-4 bg-gray-50 border-t border-gray-100">
        <div class="text-sm text-gray-600 flex items-center">
          <span class="font-medium">View All Plans</span>
        </div>
      </div>
    </a>

    <!-- Placeholder for future features -->
    <div
      class="bg-white rounded-lg shadow-lg p-6 border-2 border-dashed border-gray-200 flex items-center justify-center"
    >
      <div class="text-center">
        <div class="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mx-auto mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
        </div>
        <h3 class="text-lg font-medium text-gray-400">More Features Coming Soon</h3>
      </div>
    </div>
  </div>
</div>
